// extracted by mini-css-extract-plugin
export default {"container":"index_container_dF1QP","recNews":"index_recNews_eOYsq"};